export default "__VITE_ASSET__CTOhU4gv__"